document.addEventListener('DOMContentLoaded', () => {
	const decks = document.querySelectorAll('.deck')

	function nextCard(deck, e) {
		deck.classList.add('fwd')
		deck.classList.remove('bck')
		var index = parseInt(deck.dataset.activeCard)
		index++
		if (index > deck.children.length) {
			index = 1
		}
		deck.dataset.activeCard = index
	}

	function previousCard(deck, e) {
		deck.classList.remove('fwd')
		deck.classList.add('bck')
		var index = parseInt(deck.dataset.activeCard)
		index--
		if (index < 1) {
			index = deck.children.length
		}
		deck.dataset.activeCard = index
	}

	decks.forEach(deck => {
		deck.addEventListener('click', e => {
			nextCard(deck, e)
		})
		deck.addEventListener('mousedown', e => {
			if (e.button == 2) {
				previousCard(deck, e)
			}
		})
		deck.addEventListener('contextmenu', e => {
			e.preventDefault()
			return false
		})
		deck.addEventListener('keydown', e => {
			if (e.key === 'ArrowRight') {
				nextCard(deck, e)
			} else if (e.key === 'ArrowLeft') {
				previousCard(deck, e)
			}
		})
	})
})
